"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SearchQuery_1 = __importDefault(require("../entity/SearchQuery"));
const defaultValue = {
    query: 'query words',
    limit: 20,
    currentPage: 1,
    organizationId: [123],
    onlyMyOrganization: 0,
    industry: ['金融', 'IT'],
    height: [0, 1980],
    width: [980, 1980],
    tag: ['イラスト', 'シンプル', '特急'],
    contentType: ['video/mp3'],
    scope: [1],
};
exports.generateSearchQuery = (jsons = defaultValue) => SearchQuery_1.default.fromJSON(jsons);
